import $ from 'jquery'
import { SELECTOR } from './validation/helpers'

const TOOLTIP_CLASS = SELECTOR._TOOLTIP

export const initToolTips = () => $(TOOLTIP_CLASS).tooltip()
